import { useContext } from 'react'
import { RefreshContext } from '../contexts/RefreshContext'

const useRefresh = () => {
  const { fast, slow, ten } = useContext(RefreshContext)
  return { fastRefresh: fast, slowRefresh: slow, tenRefresh: ten }
}

export default useRefresh
